import angular from 'angular'
import importModalCtrl from './importModalCtrl'
import invoiceCollectionDetailCtrl from './invoiceCollectionDetailCtrl'
import checkImageModalCtrl from './checkImageModalCtrl'
import scanModalCtrl from './scanModalCtrl'
import CollectionModalListCtrl from './collectionModalListCtrl'

import { collection } from 'redevConfig'

const list = (collection && collection.list) || ''

const collectionListPage = list
  ? require(`redevelopment/input/collection/${list.templateName}`)
  : require('./view/collectionList.html')
const collectionListCtrl = list
  ? require(`redevelopment/input/collection/${list.controllerName}`)
  : require('./collectionListCtrl')
export default angular
  .module('input.inputInvoice.collection', [])
  .config([
    '$stateProvider',
    function config($stateProvider) {
      $stateProvider
        .state('input.inputInvoice.collection', {
          url: '/collection',
          abstract: true,
          template: '<div ui-view></div>',
          default: 'input.inputInvoice.collection.list',
          title: '发票收集',
        })
        .state('input.inputInvoice.collection.list', {
          url: '/list',
          template: collectionListPage,
          controller: 'collectionListCtrl',
        })
    },
  ])
  .controller('collectionListCtrl', collectionListCtrl.default)
  .controller('importModalCtrl', importModalCtrl)
  .controller('scanModalCtrl', scanModalCtrl)
  .controller('invoiceCollectionDetailCtrl', invoiceCollectionDetailCtrl)
  .controller('checkImageModalCtrl', checkImageModalCtrl)
  .controller('CollectionModalListCtrl', CollectionModalListCtrl).name



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/collection/index.js